import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    info: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      [theme.fn.largerThan('sm')]: {
        position: 'absolute',
        top: '20%',
        left: 0,
        bottom: 0,
      },
    },
    locator: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      [theme.fn.smallerThan('sm')]: {
        alignItems: 'stretch',
        textAlign: 'center',
      },
    },
    colLeft: {
      position: 'relative',
      [theme.fn.smallerThan('sm')]: {
        zIndex: 2,
      },
      [theme.fn.largerThan('sm')]: {
        width: '100%',
      },
    },
    colRight: {
      paddingBottom: 20,
      [theme.fn.largerThan('sm')]: {},
    },
    infoColLeft: {
      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },
    infoColRight: {
      [theme.fn.largerThan('sm')]: {
        display: 'none',
      },
    },
    chart: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
      [theme.fn.smallerThan('sm')]: {
        alignItems: 'center',
        gap: 32,
      },
    },
  }
})
